
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from 'app/utils/method';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import AssetGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/assets/asset-group/asset-group.entity';
import { ICreateAssetGroup, IUpdateAssetGroup } from './interfaces/asset-group.interface';
import { AssetGroupService } from './asset-group.service';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: 'app-asset-group',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenav,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FilterComponent,
    HoverMenuDirective,
    StatusFiltersComponent,
    ConfigurationFiltersComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './asset-group.component.html',
  styleUrl: './asset-group.component.scss'
})
export class AssetGroupComponent implements OnDestroy {
  getCode = getCode
  displayedColumns: string[] = [
    "name", 
    "statusId", 
    "action"
  ];

  dataSource = new MatTableDataSource<AssetGroupAttributes>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof AssetGroupAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  filter = {
    class: [],
    type: null
  }

  currentAssetGroup: ICreateAssetGroup = this.initializeCreateAssetGroup();
  public id: any = null

  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: number[] = [];
  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;

  constructor(
    private assetGroupService: AssetGroupService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
  ) { 
    this.form = this.fb.group({
      companyId: []
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.onFilter();
  }

  onFilter(){
    this.sidenav.close();
    this.getList()
  }

  clearFilters(): void {
    // Resetear filtros de estado
    this.selectedStatuses = [];

    // Resetear formulario con valores iniciales explícitos
    this.form.reset({
      companyId: []
    });

    // Resetear paginación y búsqueda
    this.pageIndex = 1;
    this.search = '';

    // Aplicar filtros limpios y recargar lista
    this.onFilter();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    let send = {
      companyId: this.form.get("companyId").value,
      status: this.selectedStatuses
    }

    this.assetGroupService.getAllPaginateAsset(options, send).subscribe({
      next: (res: IPaginationResult<AssetGroupAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener Condiciones de Cambio","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateAssetGroup(): ICreateAssetGroup {
    return { 
      code: "", 
    //   externalKeys: {code: null},
      name: "", 
    };
  }

//   getAllCompanies(): void {
//     this.companyService.findToComboBox().subscribe({
//       next: (res: IRequestResult<CompanyAttributes[]>) => {
//         this.companyList = res.data;
//         this.companyFilterList = this.companyList.slice();
//       },
//       error: (err) => {
//       }
//     });
//   }


  openModal(asset?: AssetGroupAttributes): void {
    // this.getAllCompanies()
    if(asset){
      this.currentAssetGroup = {
        ...asset,
        // excode: asset.externalKeys?.code ?? null,
      };
      this.id = asset._id
    }else{
      this.currentAssetGroup = this.initializeCreateAssetGroup();
      this.id = null
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '40%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit(){
    if(this.id == null){
      this.createAsset()
    }else{
      this.updateAsset(this.id)
    }
  }

  createAsset(): void {
    const createAsset: ICreateAssetGroup = { 
      ...this.currentAssetGroup, 
    //   externalKeys: this.currentAssetGroup.excode ? {code: this.currentAssetGroup.excode} : null
    };

    this.assetGroupService.create(createAsset).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateAsset(id: string): void {
   if (this.currentAssetGroup) {
      const updatedAsset: IUpdateAssetGroup = { 
        ...this.currentAssetGroup,
      };

      this.assetGroupService.update(id, updatedAsset).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if(this.dialogRef){
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, asset: AssetGroupAttributes, type?: string): void {
    const originalStatusId = asset.statusId;
    const updatedStatusId = type == 'S' ? (event ? 1 : 0): originalStatusId;

    const updateAsset = { 
      //...returnType, 
      statusId: updatedStatusId,
    };

    this.assetGroupService.update(asset._id.toString(), updateAsset).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        asset.statusId = originalStatusId; 

        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(returnType: AssetGroupAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: returnType, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(returnType._id.toString()));
  }

  delete(id: string): void {
    this.assetGroupService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
